import { atom } from "jotai";

import { BookingWizardDataAtom } from "../../stores";

export const startSlotIdSelectorAtom = atom<string | null>((get) => {
  const bookingWizardData = get(BookingWizardDataAtom);

  return bookingWizardData?.startSlotId ?? null;
});
